import COMMON_CONFIG from './common.config'

const CONFIG = {
  ...COMMON_CONFIG,
  IS_PRODUCTION: true,
  mode: 'prod',
  WEB_URL: window.location.origin,
  PREMIUM_WEB_URL: "https://mobile-cinebooks.ch/",
  API_ENDPOINT: "/api/v7/viewer/",
  PREMIUM_API_ENDPOINT: "/premium/apiPremium/viewer-v7/",
  BASE_URL: "",
};

export default CONFIG;


// WEBPACK FOOTER //
// ./src/config/prod.js